import { render, staticRenderFns } from "./BannerSimple.vue?vue&type=template&id=49561657&scoped=true&"
import script from "./BannerSimple.vue?vue&type=script&lang=js&"
export * from "./BannerSimple.vue?vue&type=script&lang=js&"
import style0 from "./BannerSimple.vue?vue&type=style&index=0&id=49561657&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49561657",
  null
  
)

export default component.exports